import { makeStyles } from '@material-ui/core/styles'
export const eventCardStyles = makeStyles((theme) => ({
  eventCard: {
    width: '95%',
    borderRadius: '1rem',
    margin: theme.spacing(2, 1),
    border: `1px solid ${theme.color.lightGray}`,
    backgroundColor: theme.color.linearGradientWhite,
  },
  eventCardActionArea: {
    height: '100%',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  eventCardActions: {
    // '&:last-child': {
    //   padding: 0,
    // },
    padding: theme.spacing(0, 1, 1, 1),
  },
  eventsTabContent: {
    height: 376,
    maxHeight: 376,
    width: '335px',
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 298px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  eventCardImage: {
    height: '120px',
    backgroundSize: 'contain',
    backgroundColor: theme.palette.components.newsBackground,
  },
  eventCardContent: {
    padding: theme.spacing(1, 1, 0, 1),
  },
  eventDateContainer: {
    display: 'flex',
    marginBottom: theme.spacing(1),
    alignItems: 'center',
  },
  eventCardIconAndDescription: {
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      background: theme.palette.button.hoverDark,
      cursor: 'pointer',
    },
    borderRadius: theme.spacing(1),
    paddingRight: '10px',
  },
  eventCardIcon: {
    marginRight: '10px',
  },
  eventCardTitle: {
    margin: theme.spacing(1, 0),
    fontWeight: 'bold',
    textDecoration: 'none',
    color: theme.palette.primary.headerText,
  },
  emptyEventListWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '90px',
  },
}))
